// import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { getTokenItem, clearTokenItem, TOKEN_KEY } from '../../utils/helpers';

// interface AuthState {
//   isAuthenticated: boolean;
// }

// // Check for token on initialization
// const checkAuth = (): boolean => {
//   const token = getTokenItem(TOKEN_KEY.AUTH_TOKEN);
//   return !!token;
// };

// const initialState: AuthState = {
//   isAuthenticated: checkAuth(),
// };

// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     setAuthenticated: (state, action: PayloadAction<boolean>) => {
//       state.isAuthenticated = action.payload;
//       console.log('Auth state updated:', action.payload); // For debugging
//     },
//     logout: (state) => {
//       state.isAuthenticated = false;
//       clearTokenItem(TOKEN_KEY.AUTH_TOKEN);
//       clearTokenItem(TOKEN_KEY.REFRESH_TOKEN);
//       console.log('User logged out'); // For debugging
//     },
//     checkAuthStatus: (state) => {
//       // Action to manually check and update auth status
//       state.isAuthenticated = checkAuth();
//       console.log('Auth status checked:', state.isAuthenticated); // For debugging
//     },
//   },
// });

// export const { setAuthenticated, logout, checkAuthStatus } = authSlice.actions;
// export default authSlice.reducer;



import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getTokenItem, clearTokenItem, TOKEN_KEY } from '../../utils/helpers';

interface User {
  id?: string;
  email?: string;
  name?: string;
  profileImage?: string;
}

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
}

const checkAuth = (): boolean => {
  const token = getTokenItem(TOKEN_KEY.AUTH_TOKEN);
  return !!token;
};

const getUserData = (): User | null => {
  try {
    const userData = localStorage.getItem('user_data');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

const initialState: AuthState = {
  isAuthenticated: checkAuth(),
  user: getUserData(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
      console.log('Auth state updated:', action.payload);
    },
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem('user_data', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('user_data');
      }
      console.log('User data updated:', action.payload);
    },
    login: (state, action: PayloadAction<{ user: User }>) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      localStorage.setItem('user_data', JSON.stringify(action.payload.user));
      console.log('User logged in:', action.payload.user);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      clearTokenItem(TOKEN_KEY.AUTH_TOKEN);
      clearTokenItem(TOKEN_KEY.REFRESH_TOKEN);
      localStorage.removeItem('user_data');
      console.log('User logged out');
    },
    checkAuthStatus: (state) => {
      state.isAuthenticated = checkAuth();
      state.user = getUserData();
      console.log('Auth status checked:', state.isAuthenticated);
    },
    updateProfileImage: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.profileImage = action.payload;
        localStorage.setItem('user_data', JSON.stringify(state.user));
        console.log('Profile image updated:', action.payload);
      }
    },
  },
});

export const { 
  setAuthenticated, 
  setUser, 
  login, 
  logout, 
  checkAuthStatus,
  updateProfileImage 
} = authSlice.actions;

export default authSlice.reducer;